import React, { useState, useEffect } from "react";
import { Typography, Paper, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AccessibilityNewIcon from "@material-ui/icons/AccessibilityNew";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import EditIcon from "@material-ui/icons/Edit";
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
// import CreateLead from "./CreateLead";
// import ConvertLead from "./ConvertLead";
import UseFetchData from "../../../hooks/UseFetchData";
import axios from 'axios';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import CreatedStockOutward from "../StockOutwards/CreateStockOutward";
import Global from "../../../Global";



const STOHeaderView = ({ InventoryDocumentID, IDMainData, PopulateData }) => {
  const classes = useStyles();
  const [isOpen, setOpen] = useState(false);
  const [Mode, setMode] = useState('');
  const [Count, setCount] = useState(0);
  const [RevNo, setRevNo] = useState(0);
  const [Num, setNum] = useState(0);
  const [IDID, SetIDID] = useState('');
  const [viewPath, setViewPath] = useState('');
  const [DocumentNo, setDocumentNo] = useState("");
  const [DocumentDate, setDocumentDate] = useState("");
  const [DocumentType, setDocumentType] = useState('');
  const [Store, setStore] = useState("");
  const [CreatedBy, setCreatedBy] = useState("");
  const [CreatedOn, setCreatedOn] = useState("");
  const [ModifiedBy, setModifiedBy] = useState("");
  const [ModifiedByON, setModifiedByOn] = useState("");
  const [Customer, setCustomer] = useState("");
  const [ToStore, setToStore] = useState("");
  const [Remarks, setRemarks] = useState(false);
  const [Response, fetchData] = UseFetchData();
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const [TransactionType, setTransactionType] = useState("");


  const handleOpenModal = () => {
    debugger;
    setOpen(true);
    SetIDID(InventoryDocumentID);
    setMode('Update');
  };

  const OpenModal = () => {
    setOpen(true);
    SetIDID("");
    // setMode('Insert');
  };

  useEffect(() => {
    GetComboData();
    // Session.set("QuotationID", QuotationID);

  }, []);


  const Openurl = async () => {
    debugger;
    // QuotationID = QuotationID == undefined ? QuotationMainData[0].id : QuotationID;
    axios.post(Global.REPORT_URL, {
      PKID: InventoryDocumentID,
      Type: 'InventoryDocument'
    })
      .then(await function (response) {
        // debugger;
        console.log(response.data);
        setViewPath(response.data);
        window.open(response.data.d);
      })
      .catch(function (error) {
        alert('error to print')
        console.log(error);
      });
  }

  const GetComboData = () => {
    // setLoading(true);
    fetchComboData("Quotation/ComboDataHeaderView");
  };


  useEffect(() => {
    debugger;
    if (IDMainData !== undefined && IDMainData.length > 0) {
      setDocumentNo(IDMainData[0].DocumentNo === null ? "" : IDMainData[0].DocumentNo);
      setDocumentDate(IDMainData[0].DocumentDate === null ? "" : IDMainData[0].DocumentDate);
      setDocumentType(IDMainData[0].DocumentType === null ? "" : IDMainData[0].DocumentType);
      setCustomer(IDMainData[0].AccountName === null ? "" : IDMainData[0].AccountName);
      setToStore(IDMainData[0].ToStore === null ? "" : IDMainData[0].ToStore);
      setStore(IDMainData[0].Store === null ? "" : IDMainData[0].Store);
      setModifiedBy(IDMainData[0].ModifiedBy === null ? "" : IDMainData[0].ModifiedBy);
      setCreatedBy(IDMainData[0].CreatedBy === null ? "" : IDMainData[0].CreatedBy);
      setCreatedOn(IDMainData[0].CreatedOn === null ? "" : IDMainData[0].CreatedOn);
      setModifiedByOn(IDMainData[0].ModifiedOn === null ? "" : IDMainData[0].ModifiedOn);
      setTransactionType(IDMainData[0].TransactionType === null ? "" : IDMainData[0].TransactionType);
    }

  }, [IDMainData]);


  return (
    <div>
      <Paper elevation={3}>
        <Typography className={classes.headertext} noWrap>
          <LocalAtmIcon style={{ fontSize: 36 }} />
          Stock Outward
          <div style={{ width: "70%" }}>
            <div style={{ float: "right", marginTop: -3 }}>
              {/* 10-feb - change */}
              <Grid container direction="row" >
                <Grid item  >
                  <BiztranControls.Button
                    text="AddNew"
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={() => {
                      OpenModal();
                    }} />
                </Grid>
                <Grid item  >
                  <BiztranControls.Button
                    text="EDIT"
                    startIcon={<EditIcon />}
                    onClick={() => {
                      handleOpenModal();
                    }} />
                </Grid>
                <Grid item  >
                  <BiztranControls.Button
                    text="Print"
                    //startIcon={<PrintIcon />}
                    onClick={() => {
                      Openurl();
                    }}
                  />
                </Grid>

              </Grid>
            </div>
          </div>
        </Typography>
        <Grid spacing={1} container style={{ marginTop: 7, paddingLeft: 10 }}>
          <Grid item xs={12} container direction="row">
            <Grid item xs={3} container direction="row">
              <h5 style={{ width: 100 }}>Document No:</h5>
              <h5 style={{ color: "#0096FF" }}>{DocumentNo}</h5>
            </Grid>
            <Grid item xs={3} container direction="row">
              <h5 style={{ width: 110 }}>Document Date:</h5>
              <h5 style={{ color: "#0096FF" }}>{DocumentDate}</h5>
            </Grid>
            <Grid item xs={3} container direction="row">
              <h5 style={{ width: 100 }}>Created BY:</h5>
              <h5 style={{ color: "#0096FF" }}>{CreatedBy}</h5>
            </Grid>
            <Grid item xs={3} container direction="row">
              <h5 style={{ width: 110 }}>On:</h5>
              <h5 style={{ color: "green" }}>{CreatedOn}</h5>
            </Grid>
          </Grid>
          <Grid item xs={12} container direction="row">
            <Grid item xs={3} container direction="row">
              <h5 style={{ width: 100 }}>Document Type:</h5>
              <h5 style={{ color: "#0096FF" }}>{DocumentType}</h5>
            </Grid>
            <Grid item xs={3} container direction="row">
              <h5 style={{ width: 110 }}>Store:</h5>
              <h5 style={{ color: "#0096FF" }}>{Store}</h5>
            </Grid>
            <Grid item xs={3} container direction="row">
              <h5 style={{ width: 100 }}>Modified By:</h5>
              <h5 style={{ color: "#0096FF" }}>{ModifiedBy}</h5>
            </Grid>
            <Grid item xs={3} container direction="row">
              <h5 style={{ width: 140 }}> On:</h5>
              <h5 style={{ color: "#0096FF" }}>{ModifiedByON}</h5>
            </Grid>
          </Grid>
          <Grid item xs={12} container direction="row">
            <Grid item xs={3} container direction="row">
              <h5 style={{ width: 140 }}>Customer / To Store:</h5>
              <h5 style={{ color: "#0096FF" }}>{Customer + " / " + ToStore}</h5>
            </Grid>
            <Grid item xs={3} container direction="row">
              <h5 style={{ width: 100 }}>Remarks:</h5>
              <h5 style={{ color: "#0096FF" }}>{Remarks}</h5>
            </Grid>
            <Grid item xs={3} container direction="row">
              <h5 style={{ width: 120 }}>Transaction Type:</h5>
              <h5 style={{ color: "#0096FF" }}>{TransactionType}</h5>
            </Grid>
          </Grid>
        </Grid>
        <ModalFrame
          title="Stock Outward Details"
          maxWidth="sm"
          isOpen={isOpen}
          setOpen={setOpen}
        >
          <CreatedStockOutward
            InventoryDocumentID={IDID}
            setOpen={setOpen}
            Mode={Mode}
            PopulateData={PopulateData}
          />
        </ModalFrame>

      </Paper>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  header: {
    width: "100%",
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    marginTop: "4.2rem",
    display: "flex",
    flexDirection: "row",
  },
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.9rem",
    fontSize: "1.8rem",
    marginTop: "4.3rem",
    display: "flex",
    flexDirection: "row",
    //   borderRadius: "1rem",
  },
}));

export default STOHeaderView;
